// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberReplaceCardReplaceCardRequest {
    static getAttributeTypeMap() {
        return CouponMemberReplaceCardReplaceCardRequest.attributeTypeMap;
    }
}
CouponMemberReplaceCardReplaceCardRequest.discriminator = undefined;
CouponMemberReplaceCardReplaceCardRequest.attributeTypeMap = [
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    }
];
//# sourceMappingURL=couponMemberReplaceCardReplaceCardRequest.js.map